<template>
  <div class="d-flex flex-column mail-editor-wrapper">
    <email-editor-toolbar
      :user-has-admin-rights="userHasAdminRights"
      :selected-template="selectedTemplate"
      :plain-text="plainText"
      @update:plain-text="$emit('update:plain-text', $event)"
      @save-template="saveTemplate"
      @close-preview="$emit('close-preview')"
      @close-editor="$emit('close-editor')"
    ></email-editor-toolbar>
    <EmailEditor
      v-if="userHasAdminRights"
      ref="emailEditor"
      :appearance="appearance"
      :min-height="minHeight"
      :locale="locale"
      :tools="tools"
      :options="options"
      @load="editorLoaded"
    />
    <div v-else id="preview-wrapper" v-html="previewHtml"></div>
  </div>
</template>

<script>
import { EmailEditor } from "vue-email-editor";
import EmailEditorToolbar from "./EmailEditorToolbar";
import b64helpers from "@/helpers/b64Helpers";

export default {
  name: "TemplateEditor",
  components: { EmailEditor, EmailEditorToolbar },
  props: {
    selectedTemplate: {
      required: false,
      type: Object,
      default: null,
    },
    design: {
      required: false,
      type: Object,
      default: null,
    },
    plainText: {
      required: true,
      type: String,
    },
    previewHtml: {
      type: String,
      required: true,
    },
    userHasAdminRights: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      minHeight: "calc(100vh - 196px)",
      locale: "en",
      tools: {
        image: {
          enabled: true,
        },
      },
      options: {},
      appearance: {
        theme: "dark",
        panels: {
          tools: {
            dock: "right",
          },
        },
      },
    };
  },
  methods: {
    saveTemplate() {
      this.$root
        .$confirm(
          this.$t("confirmSaveTemplate"),
          this.$t("confirmSaveTemplateMessage")
        )
        .then((confirmResult) => {
          if (confirmResult) {
            this.sendSave();
          }
        });
    },
    sendSave() {
      this.$refs.emailEditor.editor.exportHtml((data) => {
        data.plainText = this.plainText;
        const templateData = JSON.stringify(data);
        const base64Data = b64helpers.b64EncodeUnicode(templateData);
        this.$emit("save-template", base64Data);
      });
    },
    editorLoaded() {
      this.$refs.emailEditor.editor.loadDesign(this.design);
    },
  },
};
</script>

<style lang="css">
.mail-editor-wrapper {
  height: calc(100vh - 136px);
}
</style>
